import { element } from './dom';

/** Called when the way out is taken. */
export type ExitListener = () => void;

/**
 * What the portal puts on top of a running game: the way back, and nothing else.
 *
 * Deliberately one control. Every pixel of chrome is a pixel a toddler can press instead of playing,
 * and everything else a game might need belongs inside the game, in world space, where it can be part
 * of the art.
 *
 * The button is a large corner target because the audience aims badly, and it is HTML because it is
 * portal chrome rather than game content.
 */
export class GameChrome {
  /** Root element, appended by the shell. */
  readonly element: HTMLElement;

  readonly #title: HTMLElement;

  constructor(onExit: ExitListener) {
    this.element = element('div', 'portal-chrome-bar');

    const back = element('button', 'portal-back', '←');
    back.type = 'button';
    back.setAttribute('aria-label', 'Back to the game picker');
    back.addEventListener('click', onExit);

    this.#title = element('span', 'portal-chrome-bar__title');

    this.element.append(back, this.#title);
  }

  /** Whether the bar is on screen. */
  get visible(): boolean {
    return !this.element.hidden;
  }

  set visible(value: boolean) {
    this.element.hidden = !value;
  }

  /** Names the game currently being played. */
  setTitle(title: string): void {
    this.#title.textContent = title;
  }

  /** Removes the bar from the page. */
  dispose(): void {
    this.element.remove();
  }
}
